import { useDirectoryStar } from '@/hooks/directory/useDirectoryStar';
import { DirectoryPersonKind } from '@/services/api/requests/directory-stars';
import { IconButton } from '@chakra-ui/react';
import { Star } from 'lucide-react';

type Props = { kind: DirectoryPersonKind; id: string; starred: boolean };

const DirectoryStarButton = ({ kind, id, starred }: Props) => {
  const { toggle, isPending } = useDirectoryStar(kind, id, starred);

  return (
    <IconButton
      aria-label={starred ? 'Remove star' : 'Star person'}
      aria-pressed={starred}
      title={starred ? 'Remove star' : 'Star person'}
      icon={<Star size={22} fill={starred ? 'currentColor' : 'none'} />}
      color={starred ? 'primary.500' : 'text.mediumGray'}
      variant="ghost"
      size="sm"
      position="absolute"
      top="12px"
      right="12px"
      zIndex={1}
      isDisabled={isPending}
      onClick={toggle}
    />
  );
};

export default DirectoryStarButton;
